import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import DatePicker, { registerLocale } from 'react-datepicker';
import moment from 'moment';
import ptBR from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBR);

export const Finish = (props) => {
  const [ localData, setLocalData ] = useState([]);
  const [ startDate, setStartDate ] = useState("");
  const [ isDisabled, setIsDisabled ] = useState(true);

  useEffect(() => {
    if ( !localData.finish ) return;
    
    const { data, setData } = props.parentData;
    setData({...data, finish: [localData.finish]});
  }, [localData]);

  const handleUsage = () => {
    setIsDisabled(!isDisabled);
    setLocalData({...localData, finish: []});
  }

  const handleChange = ({target, value}, key) => {
    if ( !value ) value = target.value;

    const arr = localData.finish ? localData.finish : [];
    setLocalData({...localData, finish: {...arr, [key]: value}});
  }

  const handleDateChange = (date, key) => {
    setStartDate(date);

    const value = moment(date).format("YYYY-MM-DDTHH:mm:ss") + '.000Z';
    const arr = localData.finish ? localData.finish : [];
    setLocalData({...localData, finish: {...arr, [key]: value}});
  }

  return (
    <div className="block block__finish">
      <div className="block__body">
        <p className="title"><i className="linearicons-clock"></i> Finalização</p>

        <div className="switch__group">
          <label htmlFor="disableFilter">Habilitar finalização?</label>
          <input type="checkbox" id="disableFilter" name="disableFilters" onChange={handleUsage} checked={!isDisabled} />
          <span className="toggle" htmlFor="disableFilter" data-content={isDisabled ? "NÃO" : "SIM"} onClick={handleUsage}></span>
        </div>

        {
          !isDisabled ?
            <div className="conditions__wrapper">
              <div className="form__group form__group--inline">
                <div className="titled__group">
                  <p>Filtro:</p>
                  <Select
                    options={[
                      {label: "Finalizar por data", value: "stop_momentum"},
                    ]}
                    className="basic-select"
                    classNamePrefix="select"
                    placeholder="Selecione o filtro"
                    onChange={(e) => handleChange(e, "filter")}
                  />
                </div>

                {
                  localData.finish && localData.finish.filter === "stop_momentum" ?
                    <div className="titled__group">
                      <p>Dia e hora:</p>
                      <DatePicker
                        className="basic-input basic-date-input"
                        selected={startDate}
                        defaultValue={startDate}
                        onChange={(e) => handleDateChange(e, "value")}
                        showTimeSelect
                        placeholder="Defina a data de hora da finalização"
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        timeCaption="Hora"
                        dateFormat="dd/MM/yyyy - HH:mm"
                      />
                    </div>
                  : null
                }
              </div>
            </div>
          : null
        }
      </div>
    </div>
  )
}